<quill-view-html [content]="content" theme="snow"></quill-view-html>